module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Music-84d831cfdd539b12b51869b11b310563.svg";